module.exports = __webpack_public_path__ + "static/img/zhu-g.84f5178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ranking/zhu-g.jpg
// module id = IhL+
// module chunks = 0